import {
  EuiFlexGroup,
  EuiFlexItem,
  EuiFieldSearch,
  EuiButtonGroup,
} from "@inscopix/ideas-eui";
import { useProjectTablesTableContext } from "components/ProjectTablesTable/provider/ProjectTablesTableProvider";
import { useMemo } from "react";

/*
 * Shows a search bar and toggle for filtering tables
 * Allows for:
 * - Filtering on name/key
 * - Toggling table types (analysis and data)
 */
export const ProjectTablesSearchAndFilter = () => {
  const searchValue = useProjectTablesTableContext((s) => s.searchValue);
  const onSearchChange = useProjectTablesTableContext((s) => s.onSearchChange);
  const showHidden = useProjectTablesTableContext((s) => s.showHidden);
  const setShowHidden = useProjectTablesTableContext((s) => s.setShowHidden);
  const filterTableTypeMap = useProjectTablesTableContext(
    (s) => s.filterTableTypeMap,
  );
  const onChangeTableTypeFilter = useProjectTablesTableContext(
    (s) => s.onChangeTableTypeFilter,
  );
  // avoiding heavy EuiIcon rerenders
  const filterTypeButtons = useMemo(() => {
    const filterTableTypeOptions = [
      {
        id: "data" as const,
        label: "Show data tables only",
        iconType: "tableDensityNormal",
      },
      {
        id: "analysis" as const,
        label: "Show analysis tables only",
        iconType: "indexMapping",
      },
      {
        id: "showHidden" as const,
        label: "Show/hide hidden tables",
        iconType: "eyeClosed",
      },
    ];
    return (
      <EuiButtonGroup
        type="multi"
        legend="Filter by type"
        options={filterTableTypeOptions}
        idToSelectedMap={{ ...filterTableTypeMap, showHidden: showHidden }}
        onChange={(id) => {
          if (id === "data" || id === "analysis") onChangeTableTypeFilter(id);
          else if (id === "showHidden") setShowHidden(!showHidden);
        }}
        isIconOnly
      />
    );
  }, [filterTableTypeMap, onChangeTableTypeFilter, setShowHidden, showHidden]);

  return (
    <EuiFlexGroup gutterSize="m" alignItems="center" responsive={false}>
      <EuiFlexItem>
        <EuiFieldSearch
          fullWidth
          placeholder="Search tables..."
          value={searchValue}
          onChange={(e) => onSearchChange(e)}
          isClearable={true}
        />
      </EuiFlexItem>
      <EuiFlexItem grow={false}>{filterTypeButtons}</EuiFlexItem>
    </EuiFlexGroup>
  );
};
